export const CERTIFICATION_FLAGS = ['isLocalAssemblyMember', 'isVerified', 'hasChildProtection'];
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const badges = value => Array.isArray(value) && value.every(badge => typeof badge === 'string');
// Stored certificates and enriched directory rows carry every defaulted field.
export const isCertification = value => record(value)
  && CERTIFICATION_FLAGS.every(field => typeof value[field] === 'boolean') && badges(value.ruhiBadges);
// Privacy projections may omit fields; validate the fields that are actually sent.
export const isCertificationProjection = value => record(value)
  && CERTIFICATION_FLAGS.every(field => value[field] === undefined || typeof value[field] === 'boolean')
  && (value.ruhiBadges === undefined || badges(value.ruhiBadges));
export class CertificationRequestContractError extends Error {
  constructor() {
    super('Invalid certification request: use a member ObjectId and at least one boolean flag or string badge array.');
    this.name = 'CertificationRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
export function readCertificationRequest(memberId, payload) {
  const fields = [...CERTIFICATION_FLAGS, 'ruhiBadges'];
  if (typeof memberId !== 'string' || !/^[a-f0-9]{24}$/i.test(memberId) || !record(payload)
    || !fields.some(field => Object.hasOwn(payload, field))
    || !CERTIFICATION_FLAGS.every(field => !Object.hasOwn(payload, field) || typeof payload[field] === 'boolean')
    || Object.hasOwn(payload, 'ruhiBadges') && !badges(payload.ruhiBadges)) {
    throw new CertificationRequestContractError();
  }
  return payload;
}
